module.exports = __webpack_public_path__ + "img/language-icon.6f873b46.png";